module.exports = __webpack_public_path__ + "img/posters.f81cf8ac.jpg";